import React, { useState } from 'react';
import ApiService from '../services/apiService';
import './BalanceModal.css';
import './ButtonStyles.css';

const BalanceModal = ({ isOpen, onClose, onTopUp, userId }) => {
  const [amount, setAmount] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('telegram');

  if (!isOpen) {
    return null;
  }

  const handleTopUp = async () => {
    const numericAmount = parseInt(amount, 10);
    if (!isNaN(numericAmount) && numericAmount > 0) {
      setLoading(true);
      setError('');
      try {
        // Пополнение баланса через Supabase
        await ApiService.topUpBalance(userId || 'default_user', numericAmount);
        await ApiService.addPaymentSupabase({
          user_id: userId || 'default_user',
          amount: numericAmount,
          currency: 'stars',
          method: paymentMethod,
          status: 'success'
        });
        onTopUp(numericAmount);
        onClose();
      } catch (error) {
        console.error('Payment error:', error);
        setError(error.message || 'Произошла ошибка при пополнении');
      } finally {
        setLoading(false);
      }
    } else {
      setError('Введите корректную сумму');
    }
  };

  const handlePaymentMethodChange = (method) => {
    setPaymentMethod(method);
  };

  const quickAmounts = [50, 100, 200, 500, 1000];

  return (
    <div className="balance-modal-overlay" onClick={onClose}>
      <div className="balance-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="balance-modal-close-btn" onClick={onClose}>&times;</button>
        <h2 className="balance-modal-title">Пополнить звезды</h2>
        
        {error && (
          <div className="balance-modal-error">
            {error}
          </div>
        )}

        <div className="balance-modal-method-selector">
          <label className="balance-modal-method-label">
            <input
              type="radio"
              name="paymentMethod"
              value="telegram"
              checked={paymentMethod === 'telegram'}
              onChange={() => handlePaymentMethodChange('telegram')}
            />
            Telegram Bot
          </label>
          <label className="balance-modal-method-label">
            <input
              type="radio"
              name="paymentMethod"
              value="manual"
              checked={paymentMethod === 'manual'}
              onChange={() => handlePaymentMethodChange('manual')}
            />
            Ручное пополнение
          </label>
        </div>

        <div className="balance-modal-quick-amounts">
          {quickAmounts.map(quickAmount => (
            <button
              key={quickAmount}
              className="quick-amount-button quick-amount-button-gold"
              onClick={() => setAmount(quickAmount.toString())}
            >
              {quickAmount}
            </button>
          ))}
        </div>

        <input 
          type="number"
          className="balance-modal-input"
          placeholder="Введите количество звезд"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          autoFocus
          min="1"
        />
        
        <button 
          className="neon-button neon-button-gold"
          onClick={handleTopUp}
          disabled={loading}
        >
          {loading ? 'Обработка...' : 'Пополнить'}
        </button>

        {paymentMethod === 'telegram' && (
          <div className="balance-modal-info">
            После нажатия "Пополнить" вы будете перенаправлены в Telegram для оплаты
          </div>
        )}
      </div>
    </div>
  );
};

export default BalanceModal; 